module.exports = __webpack_public_path__ + "media/images/amenities_icons/green_screen-81c593b5c2f6b344d14e70976d0fc88a.svg";